import { Component, Input } from '@angular/core';

@Component({
    selector: 'sume-html-content-card',
    templateUrl: './html-content-card.component.html',
    styleUrls: ['./html-content-card.component.scss'],
})
export class HtmlContentCardComponent {
    @Input() tooltip: string = '';
    @Input() title: string = '';
    @Input() htmlContent: string = '';

    constructor() {}
}
